import React from "react"
import * as css from "./LegalPrivacyTable.module.css"

const columns = [
  "Catégories de données",
  "But du traitement et base légale",
  "Durée de conservation",
]

const groups = [
  {
    category:
      "Données de contact, dont votre adresse e-mail, adresse postale, cas échéant numéro de téléphone",
    rows: [
      {
        purpose:
          "Afin de permettre la prise de rendez-vous en ligne, pour le suivi de vos demandes, pour vous transmettre des informations médicales.",
        retention: "3 mois",
      },
      {
        purpose: "Mise à jour de votre dossier médical",
        retention: "Au moins 20 ans",
      },
      {
        purpose:
          "Utilisation via votre dossier médical sur la base de notre intérêt légitime lorsqu’il s’agit de vous adresser des rappels ou en cas de non-paiement de factures. En cas de litige ou d’obligation légale vos données peuvent être conservées pour la durée strictement nécessaire à ce but.",
        retention:
          "Au max. 1 an, sauf obligation légale de conservation ou en cas de litige",
      },
    ],
  },
  {
    category:
      "Données médicales transmises par pièce jointe (rapport, radiographies, ordonnance médicale, etc.)",
    rows: [
      {
        purpose:
          "Relation thérapeutique avec votre prestataire de soins. Magellan réceptionne les informations et les rend accessibles à votre prestataire de soins.",
        retention: "Au moins 20 ans",
      },
    ],
  },
  {
    category: "Envoi d’informations médicales par e-mail non crypté",
    rows: [
      {
        purpose:
          "Avec votre consentement préalable, nous pouvons vous transmettre des informations médicales par e-mail. Vous pouvez retirer votre consentement en tout temps via : mdscharmilles.ch",
        retention:
          "Vous devenez responsable de la gestion de vos données médicales dès leur réception",
      },
    ],
  },
  {
    category: "Données statistiques collectées",
    rows: [
      {
        purpose:
          "Le Site ne traite que des données personnelles anonymisées sous forme agrégée dans le but de mesurer l’audience et améliorer la qualité et la convivialité du Site. Lorsque des données personnelles sont collectées dans ce but, nous le faisons selon notre intérêt légitime.",
        retention: "Au max. 26 mois",
      },
    ],
  },
]

const rows = groups.flatMap(group =>
  group.rows.map(row => ({
    category: group.category,
    ...row,
  }))
)

const LegalPrivacyTable = () => {
  return (
    <div className={css.wrapper}>
      <table className={css.desktopTable}>
        <thead>
          <tr>
            {columns.map(column => (
              <th key={column} scope="col">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {groups.map(group =>
            group.rows.map((row, index) => (
              <tr key={`${group.category}-${index}`}>
                <td>{index === 0 ? group.category : ""}</td>
                <td>{row.purpose}</td>
                <td>{row.retention}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className={css.mobileCards}>
        {rows.map((row, index) => (
          <div className={css.card} key={`${row.category}-${index}`}>
            <div className={css.cardSection}>
              <span className={css.label}>Catégorie</span>
              <span className={css.value}>{row.category}</span>
            </div>
            <div className={css.cardSection}>
              <span className={css.label}>
                But du traitement et base légale
              </span>
              <span className={css.value}>{row.purpose}</span>
            </div>
            <div className={css.cardSection}>
              <span className={css.label}>Durée de conservation</span>
              <span className={css.value}>{row.retention}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export { LegalPrivacyTable }
